import React from "react";
import { Button, ButtonProps } from "semantic-ui-react";
import "../../App.css";

type ButtonLinkProps = { className?: string } & ButtonProps;

const ButtonLink = ({ className = "", ...props }: ButtonLinkProps) => (
  <Button basic className={["link", className].join(" ")} {...props} />
);

export default ButtonLink;
